<template>
  <div class="project-upload">
    <input @change="fileChange" ref="input" type="file" />
    <div class="trigger" @click="$refs.input.click()">
      <van-icon name="plus" />
    </div>
    <div v-for="(item, index) in homeworks" :key="index">
      <van-swipe-cell>
        <div class="item">
          <img :src="$isCdn(item.homeworkUrl)" alt="" />
          <textarea maxlength="50" placeholder="请输入作业描述" v-model="item.remark"></textarea>
        </div>
        <template #right>
          <div @click="deleteByIndex(index)" class="delete-btn">删除</div>
        </template>
      </van-swipe-cell>
    </div>
    <van-button @click="save" class="save-btn" round size="large" type="info" block>上传</van-button>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {upload, saveHomeWork, fileGetSign, attrCallback, ossUpload} from '@/api'
export default {
  data() {
    return {
      homeworks: []
    }
  },
  methods: {
    deleteByIndex(index) {
      this.homeworks.splice(index, 1)
    },
    async fileChange(file) {
      const form = new FormData()
      form.append('file', file.target.files[0])
      const result = await this.upload(form)
      if (result) {
        this.homeworks.push({
          homeworkUrl: result.data.smallPath,
          userId: '451025164096902440',
          remark: ''
        })
      }
    },

    async upload(form) {
      const flag = this.oss !== ''
      if (flag) {
        const file = form.get('file')
        const res = await fileGetSign({
          oldFilename: file.name
        })
        const value = res.data
        const ossData = {
          name: file.name,
          key: value.key,
          policy: value.policy,
          OSSAccessKeyId: value.accessid,
          success_action_status: 200,
          signature: value.signature,
          file: form.get('file')
        }
        const form1 = new FormData()
        for (const key in ossData) {
          form1.append(key, ossData[key])
        }
        const ossResult = await ossUpload(this.oss, form1)
        if (ossResult) {
          const rusult = await attrCallback({
            filename: ossData.key,
            mimeType: file.type,
            size: file.size,
            oldFilename: file.name
          })
          Object.assign(rusult.data, {fileUrl: rusult.data.fileCallVo.filename})
          return rusult
        } else {
          return false
        }
      } else {
        return await upload(form)
      }
    },

    save() {
      if (this.homeworks.length === 0) {
        this.$Toast.fail('作业不能为空')
        return false
      }
      const data = {
        courseCode: this.$route.params.code,
        homeworks: this.homeworks
      }
      saveHomeWork(data).then(res => {
        if (res.code === 0) {
          this.$Toast.success('保存成功')
          setTimeout(() => {
            this.$router.push(`/projectDetail/${this.$route.params.code}`)
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.project-upload {
  min-height: 100vh;
  padding: 12px 16px;
  padding-bottom: 100px;
  input {
    display: none;
  }
}
.trigger {
  height: 47px;
  border: 1px dashed #e7e9ef;
  border-radius: 6px;
  position: relative;
  i {
    font-size: 30px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #c0c4cc;
  }
}
.item {
  padding: 16px 14px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
  display: flex;
  align-items: center;
  border-radius: 12px;
  margin-top: 24px;
  img {
    height: 74px;
    width: 74px;
    border-radius: 4px;
    margin-right: 10px;
  }
  textarea {
    flex: 1;
    border: none;
    height: 74px;
    resize: none;
  }
}
.save-btn {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
}
.delete-btn {
  margin-left: 12px;
  width: 47px;
  text-align: center;
  line-height: 100px;
  color: #fff;
  background: #eb5252;
  box-shadow: 0px 0px 12px 0px rgba(23, 38, 71, 0.04);
  height: 100%;
  border-radius: 12px;
}
</style>
